import { useMemo } from "react";
import { endOfYear, getYear, startOfYear } from "date-fns";
import { FiltersTypes } from "../../../common/types/filters/general";
import {
    CustomSelect,
    CustomSelectOption,
} from "../../forms/CustomSelect/CustomSelect";
import { useAvailableYears } from "../../settings/Directory/useAvailableYears";
import styles from "./YearFilter.module.scss";

interface YearFilterProps {
    filters: Pick<FiltersTypes, "start" | "end">;
    onChange: (filters: Pick<FiltersTypes, "start" | "end">) => void;
}

export const YearFilter: React.FC<YearFilterProps> = ({
    filters,
    onChange,
}) => {
    const availableYears = useAvailableYears();
    const selectedYear = useMemo(() => {
        if (!filters.start || !filters.end) {
            return 0;
        }

        return getYear(filters.start);
    }, [filters]);

    const yearOptions = useMemo(() => {
        const options: Array<CustomSelectOption<number>> = availableYears.map(
            (year) => ({
                value: year,
            }),
        );

        if (availableYears.length > 1) {
            options.unshift({
                value: 0,
                label: "All time",
            });
        }

        return options;
    }, [availableYears]);

    const setYear = (year: number) => {
        onChange({
            ...filters,
            ...(year !== 0
                ? {
                      start: startOfYear(new Date(year, 1)),
                      end: endOfYear(new Date(year, 1)),
                  }
                : { start: undefined, end: undefined }),
        });
    };

    return (
        <CustomSelect
            className={styles.noBottomMargin}
            onSelected={setYear}
            dropdownKey="year-filter"
            options={yearOptions}
            value={selectedYear ?? 0}
            size="xs"
        />
    );
};
